import angular from 'angular';
import templateUrl from './edit-work-order.component.html';
import { Booked } from '../../../../core/enum/product-order-status-type';

export const EditWorkOrderComponent = {
    controller: EditWorkOrderController,
    controllerAs: "vm",
    require: {
        editForm: "^^?form"
    },
    bindings: {
        workOrder: "<"
    },
    templateUrl
};

function EditWorkOrderController($q, divisionService, employeeService, icdOfficeService,
    leadsService, productsService, productLinesService, utilityService, workOrderService) {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;
    vm.onAddProductOrder = onAddProductOrder;
    vm.onChangeDivision = onChangeDivision;
    vm.onChangeEmployee = onChangeEmployee;
    vm.onChangeLead = onChangeLead;
    vm.onChangeIcdOffice = onChangeIcdOffice;
    vm.onRemoveProductOrder = onRemoveProductOrder;
    vm.onAddCustomDetails = onAddCustomDetails;
    vm.onRemoveCustomDetails = onRemoveCustomDetails;
    vm.onAddProductOrderCustomDetails = onAddProductOrderCustomDetails;
    vm.onRemoveProductOrderCustomDetails = onRemoveProductOrderCustomDetails;
    vm.divisions;
    vm.newProductOrder; // Isolated product order not yet in the work order.
    vm.products;
    vm.productLines;
    vm.workOrder;
    vm.rogersCustomDetailsKeyList = ['SGI_ID', 'FULL_NAME', 'CUST_FIRST_NAME', 'CUST_LAST_NAME', 'Address',
        'MAP_AREA_CODE', 'SAM_KEY', 'CONTRACT_TYPE_CODE', 'YEAR', 'MONTH', 'SALES_TYPE', 'Type of Payout',
        'ORIG_CONNECT_DATE', 'COMPANY_NUMBER', 'WORK_ORDER_NUM', 'OUTLET_NUMBER', 'PROD_CAMPAIGN_CODE',
        'PRODUCT_OCCURRENCE', 'ADDRESS_SEQ', 'ACTIVITY_TYPE', 'DWOP_ORDER_STATUS', 'TYPE'];

    //TODO: Define functions for loading the office list and employee list. However, they should be loaded in limited amounts on demand
    // because loading them on init would draw a large amount of data.

    function onInit() {
        vm.workOrder = vm.workOrder || createWorkOrder();
        // This edit form always deals with a single status change per product order in the work order.
        vm.workOrder.ProductOrders = [];

        if (vm.editForm) {
            vm.editForm.$setValidity("atLeastOneProductOrder", vm.workOrder.ProductOrders.length > 0);
        }

        const divisionsLoaded = divisionService.retrieveDivisions()
            .then(function (divisions) {
                vm.divisions = divisions.filter(function (division) {
                    // Only include divisions that have a leads policy.
                    return !!division.LeadsPolicy;
                });
            });
        const defaultDivisionSet = divisionsLoaded.then(function () {
            if (vm.workOrder.DivisionID) {
                vm.workOrder.Division = vm.divisions.filter(function (division) {
                    return division.Id === vm.workOrder.DivisionID;
                })[0];
            } else if (vm.divisions.length === 1) {
                vm.workOrder.Division = vm.divisions[0];
                vm.workOrder.DivisionID = vm.workOrder.Division ? vm.workOrder.Division.Id : null;
            }
            vm.workOrder.CustomDetails = [];
            vm.customDetails = getCustomDetailsKeyListByDivision(vm.workOrder.DivisionID)
            vm.pristineCustomDetails = angular.copy(vm.customDetails);
        });
        const productsLoaded = defaultDivisionSet.then(loadWorkOrderProducts);
        const productLinesLoaded = defaultDivisionSet.then(loadWorkOrderProductLines);
        defaultDivisionSet.then(loadWorkOrderProductStatuses);
        const productOrdersInitialized = $q.all([productsLoaded, productLinesLoaded])
            .then(initializeProductOrders);
        const defaultIcdOfficeSet = defaultDivisionSet.then(function () {
            if (vm.workOrder.Division && vm.workOrder.IcdOfficeID) {
                return icdOfficeService.retrieveIcdOffices({
                    DivisionID: vm.workOrder.Division.Id
                });
            }
            return [];
        }).then(function (icdOffices) {
            const office = icdOffices.filter(function (icdOffice) {
                return icdOffice.Id === vm.workOrder.IcdOfficeID;
            })[0];
            if (office) {
                vm.workOrder.IcdOffice = office;
            }
        });


        const workOrderInitialized = $q.all([divisionsLoaded, defaultDivisionSet, productsLoaded,
            productLinesLoaded, productOrdersInitialized, defaultIcdOfficeSet]);

        vm.leadSelectOptions = createLeadsSelectOptions();
        vm.icdOfficeSelectOptions = createIcdOfficeSelectOptions();
        vm.employeeSelectOptions = createEmployeeSelectOptions();
        vm.newProductOrder = {};

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(workOrderInitialized, "Initial load failed"))
            .then(function () {
                vm.loaded = true;
            });
    }

    function onAddProductOrder() {
        const previousOrder = vm.workOrder.ProductOrders[vm.workOrder.ProductOrders.length - 1];
        if (previousOrder) {
            // Pre-select the status and effective date to reduce amount of repetitive work.
            vm.newProductOrder.Status = previousOrder.Status;
            vm.newProductOrder.ProductOrderStatusID = previousOrder.ProductOrderStatusID;
            vm.newProductOrder.EffectiveDate = previousOrder.EffectiveDate;
        } else {
            vm.newProductOrder.EffectiveDate = vm.workOrder.OrderDate;
        }
        // Product orders created through the web app are always treated as confirmed.
        vm.newProductOrder.IsConfirmed = true;
        vm.newProductOrder.Quantity = 1;
        vm.newProductOrder.CustomDetails = [];
        vm.newProductOrder.CustomDeatilsKeyList = getCustomDetailsKeyListByDivision(vm.workOrder.DivisionID)
        vm.newProductOrder.PristineCustomDetails = angular.copy(vm.newProductOrder.CustomDeatilsKeyList);
        vm.workOrder.ProductOrders.push(vm.newProductOrder);
        vm.newProductOrder = {};

        if (vm.editForm) {
            vm.editForm.$setValidity("atLeastOneProductOrder", true);
        }
    }

    function onChangeDivision() {
        const allLoaded = $q.all([
            loadWorkOrderProducts(),
            loadWorkOrderProductLines(),
            loadWorkOrderProductStatuses()
        ]);

        utilityService.showLoadingUntilResolved(allLoaded);
        vm.workOrder.ProductOrders = [];
        if (vm.icdOfficeDropDownList) {
            vm.icdOfficeDropDownList.dataSource.read();
        }
        // Push change back up to ID field.
        vm.workOrder.DivisionID = vm.workOrder.Division ? vm.workOrder.Division.Id : null;
        vm.workOrder.CustomDetails = [];
        vm.customDetails = getCustomDetailsKeyListByDivision(vm.workOrder.DivisionID)
        vm.pristineCustomDetails = angular.copy(vm.customDetails);
    }

    function getCustomDetailsKeyListByDivision(divisionID) {
        let customDetails = [];
        switch (divisionID) {
            case 35:
                customDetails = vm.rogersCustomDetailsKeyList;
                break;
            default:
                customDetails = [];
        }
        return customDetails;
    }

    function onChangeLead() {
        vm.workOrder.LeadID = vm.workOrder.Lead ? vm.workOrder.Lead.LeadID : null;
    }

    function onChangeIcdOffice() {
        if (vm.employeeDropDownList) {
            vm.employeeDropDownList.dataSource.read();
        }
        vm.workOrder.Employee = null;
        vm.workOrder.IcdOfficeID = vm.workOrder.IcdOffice ? vm.workOrder.IcdOffice.Id : null;
    }

    function onChangeEmployee() {
        vm.workOrder.Employment = vm.workOrder.IcdOffice && vm.workOrder.Employee ? {
            IcdOfficeID: vm.workOrder.IcdOffice.Id,
            EmployeeID: vm.workOrder.Employee.Id
        } : null;
    }

    function onRemoveProductOrder(productOrder) {
        vm.workOrder.ProductOrders = vm.workOrder.ProductOrders.filter(function (order) {
            return order !== productOrder;
        });
        if (vm.editForm) {
            vm.editForm.$setValidity("atLeastOneProductOrder", vm.workOrder.ProductOrders.length > 0);
        }
    }

    function onAddCustomDetails() {
        if (vm.customDetail && vm.customDetail.Key && vm.customDetail.Value) {
            vm.workOrder.CustomDetails = vm.workOrder.CustomDetails || [];
            vm.workOrder.CustomDetails.push({ Key: vm.customDetail.Key, Value: vm.customDetail.Value });
            vm.customDetail.Value = null;
            vm.customDetails = getAvailableCustomDetailKeys(vm.workOrder.CustomDetails, vm.pristineCustomDetails);
        }
    }

    function onRemoveCustomDetails(customDeatil) {
        const index = vm.workOrder.CustomDetails.indexOf(customDeatil);
        if (index > -1) {
            vm.workOrder.CustomDetails.splice(index, 1);
            vm.customDetails = getAvailableCustomDetailKeys(vm.workOrder.CustomDetails, vm.pristineCustomDetails);
        }
    }

    function onAddProductOrderCustomDetails(productOrder) {
        if (productOrder.CustomDetail && productOrder.CustomDetail.Key && productOrder.CustomDetail.Value) {
            productOrder.CustomDetails = productOrder.CustomDetails || [];
            productOrder.CustomDetails.push({
                Key: productOrder.CustomDetail.Key,
                Value: productOrder.CustomDetail.Value
            });
            productOrder.CustomDetail.Value = null;
            productOrder.CustomDeatilsKeyList = getAvailableCustomDetailKeys(productOrder.CustomDetails,
                productOrder.PristineCustomDetails);
        }
    }


    function onRemoveProductOrderCustomDetails(productOrder, customDetail) {
        const index = productOrder.CustomDetails.indexOf(customDetail);
        if (index > -1) {
            productOrder.CustomDetails.splice(index, 1);
            productOrder.CustomDeatilsKeyList = getAvailableCustomDetailKeys(productOrder.CustomDetails,
                productOrder.PristineCustomDetails);
        }
    }

    function getAvailableCustomDetailKeys(curentCustomeDetails, allcustomeDetails) {
        if (curentCustomeDetails) {
            const filterCustomDetails = allcustomeDetails.filter(function (detail) {
                return !curentCustomeDetails.some(p => p.Key === detail);
            });
            return angular.copy(filterCustomDetails);
        }
    }

    function initializeProductOrders() {
        vm.workOrder.ProductOrders.forEach(function (productOrder) {
            if (productOrder.ProductID) {
                productOrder.Product = vm.products.filter(function (product) {
                    return product.ProductID === productOrder.ProductID;
                })[0];
            }
            if (productOrder.ProductLineID) {
                productOrder.ProductLine = vm.productLines.filter(function (productLine) {
                    return productLine.ProductLineID === productOrder.ProductLineID;
                })[0];
            }
        });
    }

    function loadWorkOrderProducts() {
        return $q.when((function () {
            if (vm.workOrder.Division) {
                return productsService.retrieveProducts(vm.workOrder.Division.Id);
            }
            return [];
        })()).then(function (products) {
            vm.products = products;
        });
    }

    function loadWorkOrderProductLines() {
        return $q.when((function () {
            if (vm.workOrder.Division) {
                return productLinesService.retrieveProductLines(vm.workOrder.Division.Id);
            }
            return [];
        })()).then(function (productLines) {
            vm.productLines = productLines;
        });
    }

    function loadWorkOrderProductStatuses() {
        return $q.when((function () {
            if (vm.workOrder.Division) {
                return workOrderService.retrieveProductOrderStatuses(vm.workOrder.Division.Id);
            }
            return [];
        })()).then(function (statuses) {
            vm.statuses = statuses;
            vm.bookedStatuses = statuses.filter(p => p.ProductOrderStatusType === Booked.key);
            vm.workOrder.BookedStatus = vm.bookedStatuses.find(p => p.Name === Booked.key);
        });
    }

    function createWorkOrder() {
        return {
            ProductOrders: []
        };
    }

    function createLeadsSelectOptions() {
        return {
            dataSource: {
                serverFiltering: true,
                serverPaging: true,
                pageSize: 10,
                transport: {
                    read: onLeadsDataSourceRead
                }
            },
            filter: "contains"
        };
    }

    function createEmployeeSelectOptions() {
        return {
            dataSource: {
                serverFiltering: true,
                serverPaging: true,
                pageSize: 10,
                transport: {
                    read: onEmployeeDataSourceRead
                }
            },
            filter: "contains"
        };
    }

    function createIcdOfficeSelectOptions() {
        return {
            dataSource: {
                transport: {
                    read: onIcdOfficeDataSourceRead
                }
            }
        };
    }

    function onLeadsDataSourceRead(options) {
        const query = {
            pageIndex: options.data.pageIndex,
            pageSize: options.data.pageSize
        };
        if (vm.workOrder.Division) {
            query.DivisionID = vm.workOrder.Division.Id;
        }
        if (options.data.filter && options.data.filter.filters && options.data.filter.filters.length > 0) {
            query.DivisionLeadID = options.data.filter.filters[0].value;
        }
        leadsService.retrieveLeads(query)
            .then(function (leads) {
                leads.forEach(function (lead) {
                    lead.Text = lead.DivisionLeadID;
                    if (lead.Address) {
                        const address = lead.Address;
                        lead.Text += " - " + address.StreetLine1 + (address.StreetLine2 ? " " + address.StreetLine2 : "")
                            + (address.City ? ", " + address.City : "")
                            + (address.StateName ? ", " + address.StateName : "")
                            + (address.CountryName ? ", " + address.CountryName : "");
                    }
                });
                if (vm.workOrder.Lead && vm.workOrder.Lead.LeadID && !leads.filter(function (lead) {
                    return lead.LeadID === vm.workOrder.Lead.LeadID;
                }).length > 0) {
                    leads.unshift(vm.workOrder.Lead);
                }
                options.success(leads);
            })
            .catch(function (ex) {
                options.error(ex);
            });
    }

    function onIcdOfficeDataSourceRead(options) {
        if (!vm.workOrder.Division) {
            options.success([]);
            return;
        }

        icdOfficeService.retrieveIcdOffices({
            DivisionID: vm.workOrder.Division.Id
        })
            .then(function (offices) {
                offices.forEach(function (office) {
                    office.Text = office.IcdCorporationName + " - " + office.OfficeName;
                });
                return offices;
            })
            .then(function (offices) {
                options.success(offices);
            })
            .catch(function (ex) {
                options.error(ex);
            });
    }

    function onEmployeeDataSourceRead(options) {
        const query = {
            pageIndex: options.data.pageIndex,
            pageSize: options.data.pageSize,
            showTerminated: true
        };
        if (vm.workOrder.IcdOffice) {
            query.icdOfficeID = vm.workOrder.IcdOffice.Id;
        } else {
            // Don't return any data if no office is selected.
            options.success([]);
            return;
        }
        if (options.data.filter && options.data.filter.filters && options.data.filter.filters.length > 0) {
            query.FullName = options.data.filter.filters[0].value;
        }
        employeeService.retrieveEmployees(query)
            .then(function (employees) {
                employees.forEach(function (employee) {
                    employee.Text = employee.FirstName + " " + employee.LastName;
                });
                if (vm.workOrder.Employee && vm.workOrder.Employee.Id && !employees.filter(function (employee) {
                    return employee.Id === vm.workOrder.Employee.Id;
                }).length > 0) {
                    employees.unshift(vm.workOrder.Employee);
                }
                options.success(employees);
            })
            .catch(function (ex) {
                options.error(ex);
            });
    }
}
